<div #header class="horizontal-container header-container">
    <img (click)="router.navigate(['/'])" class="clickable logo" src="assets/logo.png" alt="Dogo Logo" />
    <span class="fill-space"></span>
    <div class="dropdown">
        <i *ngIf="showHamburgurMenu" class="fa fa-bars"></i>
        <ul class="options">
            <li [style.color]="activeSection === 'features' ? '#0088cc': 'unset'" (click)="onClickFeatures.next()">Features</li>
            <li [style.color]="activeSection === 'details' ? '#0088cc': 'unset'" (click)="onClickDetails.next()">Details</li>
            <li [style.color]="activeSection === 'concept' ? '#0088cc': 'unset'" (click)="onClickConcept.next()">Concept</li>
            <li [style.color]="activeSection === 'opportunities' ? '#0088cc': 'unset'" (click)="onClickOpportunities.next()">Opportunities</li>
        </ul>
    </div>
</div>